const buildTravelerNamesByRate = (rows) => {
  const byRate = {};
  (rows || []).forEach((row) => {
    const name = [row.firstName, row.lastName]
      .map((part) => (part || '').trim())
      .filter(Boolean)
      .join(' ');
    if (!name || !row.rateName) {
      return;
    }
    byRate[row.rateName] = [...(byRate[row.rateName] || []), name];
  });

  return byRate;
};

const readPickup = (text) => {
  const pickup = /[a-z0-9]/i.test(text || '') ? text : undefined;
  return pickup;
};

const buildTourBookingInput = ({
  segmentId,
  tourTravelers,
  tourTravelerQuestions,
  tourOperatorNotes,
  tourHotelPickup,
}) => {
  if (segmentId == null) {
    return undefined;
  }

  const travelerNamesByRate = buildTravelerNamesByRate(tourTravelers && tourTravelers[segmentId]);

  return {
    travelerNamesByRate: Object.keys(travelerNamesByRate).length ? travelerNamesByRate : undefined,
    travelerQuestions: (tourTravelerQuestions && tourTravelerQuestions[segmentId]) || undefined,
    operatorNotes: (tourOperatorNotes && tourOperatorNotes[segmentId]) || undefined,
    hotelPickup: readPickup(tourHotelPickup && tourHotelPickup[segmentId]),
  };
};

export default buildTourBookingInput;
